import { useParams } from "react-router-dom";
function LanguageSelection(props) {
  const {changeLanguageHandler, t, values, step} = props;
  const { locale,isParmEmbassyCode,selectedEmbassyCode,hideEnglishLanguage } = values;
  console.log("language step", step); 
  
  const { embassycode } = useParams();
  return (


    


    !hideEnglishLanguage &&

    <div className="col-sm-12 language-selection always-right">
      
    {isParmEmbassyCode && step && step.id !== "select-embassy" && <a href={selectedEmbassyCode.toLowerCase()} className="d-inline-block px-2"><img src="./images/home-icon.svg" alt="home page" /></a> }
    {!isParmEmbassyCode && step && step.id !== "select-embassy" && <a href='/embassy' className="d-inline-block px-2"><img src="./images/home-icon.svg" alt="home page" /></a> }

    <button onClick={ () => changeLanguageHandler() }>
      { locale === "ar" && <img src="./images/flag-icon-us.svg" alt="switch language" className="mx-1 flag-icon rounded-full" /> }
      <span>{t("SELECTED_LANGUAGE")}</span>
      {embassycode &&  embassycode!='sd' && locale === "en" && <img src="./images/flag-icon-uae.svg" alt="switch language" className="mx-1 flag-icon" /> }   
      {embassycode &&  embassycode=='sd' && locale === "en"  && <img  src="./images/sudan-flag.svg" alt="switch language" className="mx-1 flag-icon" /> }   
      { !embassycode  && locale === "en" && <img src="./images/flag-icon-uae.svg" alt="switch language" className="mx-1 flag-icon" /> }    
    </button>
  </div>
    
   
  );
}
export default LanguageSelection;
